<template>
  <div>
    <div class="page-header row">
      <slot name="printHeader">
        <div class="col-2">
          <img
            src="/static/img/bsa/woodbadge-horizontal-black.png"
            style="height: 40px;width:168px;"
          >
        </div>
        <div class="col-10 text-right">
          <span class="h2">{{ title }}</span>
        </div>
      </slot>
    </div>

    <div class="page-footer">
      <slot name="printFooter">
        <div class="row">
          <div class="col-4 text-muted">
            {{ $root.courseName }}
          </div>
          <div class="col-4 text-center text-muted page-number" />
          <div class="col-4 text-right text-muted">
            powered by www.two-beads.com
          </div>
        </div>
      </slot>
    </div>

    <table>
      <thead>
        <tr>
          <td>
            <!--place holder for the fixed-position header-->
            <div class="page-header-space" />
          </td>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            <div class="page">
              <slot name="printContent" />
            </div>
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td>
            <!--place holder for the fixed-position footer-->
            <div class="page-footer-space" />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Printer',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
